<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">求助电话管理详情</div>
      </zj-layout-header>
    </zj-layout-container>
    <!-- prop="ResourceName" -->
    <el-form-item label="单位名称" prop="CompanyName">
      <el-input
        v-model="ruleForm.CompanyName"
        style="width:118rem;"
        v-bind:disabled="IsEdit"
        placeholder="请输入单位名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="求助电话" prop="CompanyPhone">
      <el-input
        v-model="ruleForm.CompanyPhone"
        placeholder="请输入求助电话"
        style="width:118rem;"
        v-bind:disabled="IsEdit"
      ></el-input>
    </el-form-item>

    <el-form-item class="right" style="width:134rem;">
      <el-button @click="onBack()">返回</el-button>
      <el-button type="primary" @click="submitForm()" v-show="IsEdit == false"
        >保存</el-button
      >
      <!-- <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button> -->
    </el-form-item>
  </el-form>
</template>
<script>
import MyApis from "../../../apis";
import utils from "../../../../../../utils";
import ZJApp from "../../../../../app";
export default {
  name: "CallForHelpInfo",
  controller: "UI",
  action: "CallForHelpInfo",
  data() {
    return {
      ruleForm: {
        CompanyName: "",
        CompanyPhone: "",
      },
      rules: {
        CompanyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        CompanyPhone: [
          { required: true, message: "请输入求助电话", trigger: "blur" },
        ],
      },
      IsEdit: false,
    };
  },
  created: function() {
    if (this.$route.query.Id) {
      this.search();
    }
    this.IsEdit = this.$route.query.type == "look" ? true : false;
  },
  mounted: function() {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    search() {
      let Id = this.$route.query.Id;
      if (Id) {
        let searchInfo = {
          Id: Id,
        };
        new MyApis.TranResourcesApi()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.ruleForm = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    submitForm() {
      if (!this.ruleForm.CompanyName) {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入用户名",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }

      if (!utils.isRightMobileNum(this.ruleForm.CompanyPhone)) {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入正确的手机号",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }
      if (this.$route.query.type == "edit") {
        this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
        new MyApis.TranResourcesApi()
          .UpdateItem(this.ruleForm)
          .then((r) => {
            r = r.data.Data;
            this.is_login = true;
            this.logInfo.ActionName = "求助电话修改";
            this.logInfo.LogMessage = "求助电话修改成功";
            this.logInfo.ModuleName = "紧急求助";
            this.logInfo.PageName = "求助电话管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            console.log(r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        let obj = {
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
        };
        let formAll = Object.assign(obj, this.ruleForm);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.is_login = true;
            this.logInfo.ActionName = "求助电话添加";
            this.logInfo.LogMessage = "求助电话添加成功";
            this.logInfo.ModuleName = "紧急求助";
            this.logInfo.PageName = "求助电话管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            console.log(r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
